const ITEMS = [
  "Master Your Energy",
  "Grow Your Life",
  "Protect What You Build",
  "Unlock Peak Performance",
  "Deep Rest",
  "Real Focus",
];

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-blue-100/80 bg-white py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[...ITEMS, ...ITEMS].map((text, i) => (
          <span
            key={i}
            className="flex items-center font-display text-sm font-semibold uppercase tracking-[0.35em] text-slate-400"
          >
            <span className="px-8">{text}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-blue-300" />
          </span>
        ))}
      </div>
    </section>
  );
}
